import { useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../api/client';

export default function ImportarSiembras() {
  const [filas, setFilas] = useState([]);
  const [nombreArchivo, setNombreArchivo] = useState('');
  const [importando, setImportando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState(null);

  // Mapeo de columnas del Excel a las claves del backend
  const MAPEO_COLUMNAS = {
    'sector': 'sector',
    'piscina': 'piscina',
    'area': 'area',
    'fecha siembra': 'fecha_siembra',
    'fecha_siembra': 'fecha_siembra',
    'corrida': 'numero_corrida',
    'numero corrida': 'numero_corrida',
    'numero_corrida': 'numero_corrida',
    'n corrida': 'numero_corrida',
    'peso siembra': 'peso_siembra',
    'peso_siembra': 'peso_siembra',
    'animales sembrados': 'animales_sembrados',
    'animales_sembrados': 'animales_sembrados',
  };

  const handleArchivo = (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;

    setNombreArchivo(archivo.name);
    setError(null);
    setResultado(null);

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array', cellDates: true });
        const primeraHoja = workbook.SheetNames[0];
        const hoja = workbook.Sheets[primeraHoja];

        const rows = XLSX.utils.sheet_to_json(hoja, { defval: '' });

        if (rows.length === 0) {
          setError('El archivo está vacío o no tiene datos en la primera hoja');
          setFilas([]);
          return;
        }

        const normalizar = (s) =>
          s.toString().trim().toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

        const filasNormalizadas = rows.map((row) => {
          const fila = {};
          Object.keys(row).forEach((key) => {
            const clave = normalizar(key);
            const campo = MAPEO_COLUMNAS[clave] || clave;
            let valor = row[key];

            // Convertir fecha_siembra a formato YYYY-MM-DD
            if (campo === 'fecha_siembra' && valor) {
              if (valor instanceof Date) {
                const y = valor.getFullYear();
                const m = String(valor.getMonth() + 1).padStart(2, '0');
                const d = String(valor.getDate()).padStart(2, '0');
                valor = `${y}-${m}-${d}`;
              } else if (typeof valor === 'number') {
                // Excel serial date
                const fechaExcel = new Date((valor - 25569) * 86400 * 1000);
                const y = fechaExcel.getUTCFullYear();
                const m = String(fechaExcel.getUTCMonth() + 1).padStart(2, '0');
                const d = String(fechaExcel.getUTCDate()).padStart(2, '0');
                valor = `${y}-${m}-${d}`;
              } else {
                // String
                const s = String(valor).trim();
                const m1 = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
                const m2 = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
                if (m1) {
                  valor = `${m1[3]}-${m1[2].padStart(2, '0')}-${m1[1].padStart(2, '0')}`;
                } else if (m2) {
                  valor = `${m2[1]}-${m2[2].padStart(2, '0')}-${m2[3].padStart(2, '0')}`;
                }
              }
            }

            // Corrida: convertir a número
            if (campo === 'numero_corrida' && valor !== '' && valor !== null) {
              const n = parseInt(String(valor).trim());
              valor = isNaN(n) ? null : n;
            }

            // Números: acepta coma o punto
            if ((campo === 'area' || campo === 'peso_siembra' || campo === 'animales_sembrados') && valor !== '') {
              if (typeof valor === 'string') {
                valor = valor.replace(/\s/g, '').replace(',', '.');
              }
              const n = parseFloat(valor);
              valor = isNaN(n) ? null : n;
            }

            fila[campo] = valor;
          });
          return fila;
        });

        setFilas(filasNormalizadas);
        console.log('Primera fila leída:', filasNormalizadas[0]);
      } catch (err) {
        console.error(err);
        setError('Error al leer el archivo: ' + err.message);
        setFilas([]);
      }
    };
    reader.readAsArrayBuffer(archivo);
  };

  const importar = async () => {
    if (filas.length === 0) return;
    if (!confirm(`¿Importar ${filas.length} filas? Esta acción modificará la base de datos.`)) return;

    setImportando(true);
    setError(null);
    setResultado(null);

    try {
      const { data } = await api.post('/importar/siembras', { filas });
      setResultado(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al importar');
    } finally {
      setImportando(false);
    }
  };

  const limpiar = () => {
    setFilas([]);
    setNombreArchivo('');
    setResultado(null);
    setError(null);
  };

  const descargarPlantilla = () => {
    const plantilla = [
      {
        'Sector': 'Sector A',
        'Piscina': 'Ps 01',
        'Area': 7.54,
        'Fecha Siembra': '17/02/2026',
        'Corrida': 1,
        'Peso Siembra': 0.43,
        'animales sembrados': 1357200,
      },
      {
        'Sector': 'Sector A',
        'Piscina': 'Ps 02',
        'Area': 7.50,
        'Fecha Siembra': '20/03/2026',
        'Corrida': 1,
        'Peso Siembra': 0.96,
        'animales sembrados': 1350000,
      },
    ];
    const ws = XLSX.utils.json_to_sheet(plantilla);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Siembras');
    XLSX.writeFile(wb, 'plantilla_siembras.xlsx');
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6 flex-wrap gap-3">
          <button
          onClick={descargarPlantilla}
          className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 flex items-center gap-2 text-sm"
        >
          📥 Descargar plantilla
        </button>
      </div>

      <div className="mb-4 p-3 bg-blue-50 text-blue-900 rounded text-sm">
        <strong>💡 Cómo funciona:</strong> Para cargar información independiente de la tecnología
        que se use en finca. Sube un archivo Excel (.xlsx o .xls) con las columnas
        <code className="mx-1 px-1 bg-white rounded text-xs">Sector</code>,
        <code className="mx-1 px-1 bg-white rounded text-xs">Piscina</code>,
        <code className="mx-1 px-1 bg-white rounded text-xs">Area</code>,
        <code className="mx-1 px-1 bg-white rounded text-xs">Fecha Siembra</code>,
        <code className="mx-1 px-1 bg-white rounded text-xs">Corrida</code>,
        <code className="mx-1 px-1 bg-white rounded text-xs">Peso Siembra</code> y
        <code className="mx-1 px-1 bg-white rounded text-xs">animales sembrados</code>.
        Los sectores y piscinas que no existan se crearán automáticamente.
      </div>

      {/* Zona de carga */}
      <div className="bg-white p-6 rounded shadow mb-6">
        <label className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition">
          <div className="flex flex-col items-center">
            <svg className="w-12 h-12 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            <p className="text-sm text-gray-600">
              {nombreArchivo ? (
                <span className="font-semibold text-primary">{nombreArchivo}</span>
              ) : (
                <span>Haz clic para seleccionar un archivo Excel</span>
              )}
            </p>
            <p className="text-xs text-gray-400 mt-1">.xlsx, .xls</p>
          </div>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleArchivo}
            className="hidden"
          />
        </label>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-800 rounded">{error}</div>
      )}

      {/* Preview */}
      {filas.length > 0 && !resultado && (
        <>
          <div className="flex justify-between items-center mb-3">
            <h2 className="text-lg font-semibold">
              Vista previa ({filas.length} filas)
            </h2>
            <div className="flex gap-2">
              <button
                onClick={limpiar}
                className="px-4 py-2 border rounded hover:bg-gray-100 text-sm"
              >
                Cancelar
              </button>
              <button
                onClick={importar}
                disabled={importando}
                className="px-5 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 font-medium text-sm flex items-center gap-2"
              >
                {importando ? '⏳ Importando...' : '✅ Importar a la base de datos'}
              </button>
            </div>
          </div>

          <div className="bg-white rounded shadow overflow-hidden">
            <div className="overflow-x-auto max-h-[400px]">
              <table className="w-full text-xs">
                <thead className="bg-gray-100 sticky top-0">
                  <tr>
                    <th className="text-left px-3 py-2 font-semibold">Sector</th>
                    <th className="text-left px-3 py-2 font-semibold">Piscina</th>
                    <th className="text-right px-3 py-2 font-semibold">Area</th>
                    <th className="text-left px-3 py-2 font-semibold">Fecha Siembra</th>
                    <th className="text-center px-3 py-2 font-semibold">Corrida</th>
                    <th className="text-right px-3 py-2 font-semibold">Peso Siembra</th>
                    <th className="text-right px-3 py-2 font-semibold">Animales Sembrados</th>
                  </tr>
                </thead>
                <tbody>
                  {filas.slice(0, 100).map((f, i) => (
                    <tr key={i} className="border-t hover:bg-gray-50">
                      <td className="px-3 py-2">{String(f.sector || '')}</td>
                      <td className="px-3 py-2 font-medium">{String(f.piscina || '')}</td>
                      <td className="px-3 py-2 text-right">{String(f.area ?? '')}</td>
                      <td className="px-3 py-2">{String(f.fecha_siembra || '')}</td>
                      <td className="px-3 py-2 text-center">{String(f.numero_corrida ?? '')}</td>
                      <td className="px-3 py-2 text-right">{String(f.peso_siembra ?? '')}</td>
                      <td className="px-3 py-2 text-right">
                        {typeof f.animales_sembrados === 'number'
                          ? f.animales_sembrados.toLocaleString('es-EC')
                          : String(f.animales_sembrados || '')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {filas.length > 100 && (
                <div className="p-2 text-center text-xs text-gray-500 bg-gray-50">
                  Mostrando primeras 100 filas de {filas.length}
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Resultado */}
      {resultado && (
        <div className="bg-white p-6 rounded shadow">
          <h2 className="text-xl font-bold text-green-700 mb-4">✅ Importación completada</h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-blue-50 p-4 rounded">
              <div className="text-xs text-gray-600">Filas procesadas</div>
              <div className="text-2xl font-bold text-blue-700">{resultado.procesadas}</div>
            </div>
            <div className="bg-green-50 p-4 rounded">
              <div className="text-xs text-gray-600">Sectores creados</div>
              <div className="text-2xl font-bold text-green-700">{resultado.sectoresCreados}</div>
            </div>
            <div className="bg-purple-50 p-4 rounded">
              <div className="text-xs text-gray-600">Piscinas creadas</div>
              <div className="text-2xl font-bold text-purple-700">{resultado.piscinasCreadas}</div>
            </div>
            <div className="bg-orange-50 p-4 rounded">
              <div className="text-xs text-gray-600">Piscinas actualizadas</div>
              <div className="text-2xl font-bold text-orange-700">{resultado.piscinasActualizadas}</div>
            </div>
            <div className="bg-teal-50 p-4 rounded">
              <div className="text-xs text-gray-600">Siembras creadas</div>
              <div className="text-2xl font-bold text-teal-700">{resultado.siembrasCreadas}</div>
            </div>
            <div className="bg-yellow-50 p-4 rounded">
              <div className="text-xs text-gray-600">Siembras actualizadas</div>
              <div className="text-2xl font-bold text-yellow-700">{resultado.siembrasActualizadas}</div>
            </div>
          </div>

          {resultado.errores?.length > 0 && (
            <div className="mt-4">
              <h3 className="font-semibold text-red-700 mb-2">
                Errores ({resultado.errores.length})
              </h3>
              <div className="bg-red-50 border border-red-200 rounded p-3 max-h-60 overflow-y-auto">
                {resultado.errores.map((e, i) => (
                  <div key={i} className="text-sm text-red-800 mb-1">
                    <strong>Fila {e.fila}:</strong> {e.error}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="mt-6 flex gap-2">
            <button
              onClick={limpiar}
              className="px-4 py-2 bg-primary text-white rounded hover:bg-blue-800"
            >
              Importar otro archivo
            </button>
            <a
              href="/configuracion"
              className="px-4 py-2 border rounded hover:bg-gray-100"
            >
              Ir a Configuración
            </a>
          </div>
        </div>
      )}
    </div>
  );
}